import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';
//import { Link as ScrollLink } from 'react-scroll';
import { sanitizeHtml } from 'utils';

import primaryVideo from '../../../../../asset/resource/dd-energy.mp4';
import staticBackground from '../../../../../asset/resource/static-bg.png';

import './Title.scss';

export const Title = ({ data }) => {
  const [isVideoReady, setVideoReadyStatus] = useState(false);
  const [isSafariBrowser, setIsSafariBrowser] = useState(false);
  const [descriptionHeight, setDescriptionHeight] = useState(0);
  const { preTitle, title, description } = data;

  useEffect(() => {
    let isSafari = window.navigator.vendor.toLowerCase().indexOf('apple') > -1;
    if (isSafari) setIsSafariBrowser(true);
  }, [isSafariBrowser]);

  function calculateDescriptionHeight() {
    const descriptionTagHeight = document.querySelector('.main-title__description-block').offsetHeight;
    setDescriptionHeight(descriptionTagHeight / 2);
  }

  useEffect(() => {
    calculateDescriptionHeight();
    window.addEventListener('resize', calculateDescriptionHeight);

    const videoElement = document.getElementById('hero-video');
    videoElement.addEventListener('loadeddata', () => {
      setVideoReadyStatus(true);
    });

    return () => {
      window.removeEventListener('resize', calculateDescriptionHeight);
    };
  }, []);

  const descriptionStyles = {
    position: 'relative',
    top: `-${descriptionHeight}px`,
    marginBottom: `-${descriptionHeight}px`,
  };

  const descriptionAnimation = {
    initial: { y: 200, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    transition: { ease: 'easeOut', duration: 1.5 },
  };

  return (
    <>
      <section className={cn('main-title')}>
        <div className="main-title__wrapper">
          <div>
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(preTitle) }}></div>
            <h1 dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }}></h1>
          </div>
        </div>
        <video
          id="hero-video"
          className="main-title__hero-video"
          style={{ display: isVideoReady ? 'block' : 'none' }}
          loop
          muted
          playsInline
          autoPlay
        >
          <source src={primaryVideo} type="video/mp4" />
        </video>
        <img
          src={staticBackground}
          fetchpriority="high"
          style={{ display: isVideoReady ? 'none' : 'block' }}
          className="main-title__hero-video"
        />
      </section>
      <motion.div style={descriptionStyles} className="main-title__description-block_wrapper" {...descriptionAnimation}>
        <div className="main-title__description-block">{description}</div>
      </motion.div>
      {/* <section className="main-title__extended-description">
        <div className="wrapper main-title__extended-description-content">
          <p
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(descriptionLeft) }}
          />
          <p
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(descriptionRight) }}
          />
        </div>
      </section> */}
    </>
  );
};

export default Title;
